import store from '@/store/index'
const authorityDirective = {}
// 自定义指令 权限判断是否显示标签
authorityDirective.install = Vue => {
  Vue.directive('authority', {
    inserted (el, binging) {
      const authorityMenu = isShowMenu(binging.value.title)
      if (authorityMenu.length) {
        el.parentNode.removeChild(el)
      }
    }
  })
}

function isShowMenu (title) {
  const state = store.state.user.authorityList
  console.log('state输出权限', store.state.user.authorityList)
  return state.filter(item => item.action_name === title)
}

export default {
  install (Vue) {
    Vue.use(authorityDirective)
  }
  // directive: authorityDirective
}
